import styles from './LandingAboutUs.module.css';

const LandingAboutUs = (props) => {
	return (
		<div className={styles.landing}>
			<h1 className='text-4xl mt-20'>About Us</h1>
			<p className='mt-14 text-center'>
				Hath after appear tree great fruitful green dominion moveth sixth
				abundantly <br />
				image that midst of god day multiply you’ll which
			</p>
		</div>
	);
};

export default LandingAboutUs;
